import { GET_USERINFO } from '../mutation-types';

const state = {
  data: null
};

const getters = {
  // eslint-disable-next-line no-shadow 
  GET_USERINFO: state => state.data
};

const mutations = {
  // eslint-disable-next-line no-shadow
  [GET_USERINFO]: (state, payload) => {
    state.data = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  [GET_USERINFO]: async (context, payload) => {
    const { data } = await Ajax.get('/api/usercenter/describeBaseInfo');
    context.commit(GET_USERINFO, data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js